<fieldset class="bordas" [style]="'width: auto'">
    <div>
        <div fxLayout="column" fxFlex="90%">
            <div fxLayout="row" fxLayoutGap="20px">
                <div ngModelGroup="comboMetaAcao_{{idRandomico}}" fxFlex="100">
                    <combo-meta-acao [showDisplayId]="false"
                                     [obrigatorio]="true"
                                     [selecionado]="meta.metaAcao?.metaObjetivo ? meta.metaAcao?.metaObjetivo : meta.combo"
                                     (valorChange)="onValorChangeMeta($event)"
                                     [metasAcao]="metasAcao">
                    </combo-meta-acao>
                </div>
            </div>
        </div>

        <div fxLayout="column" fxFlex="10%" fxLayoutAlign="center center">
            <button mat-icon-button *ngIf="perfilAcesso.deleta" (click)="deletar()" style="padding: 0px;">
                <mat-icon>delete_forever</mat-icon>
            </button>
        </div>
    </div>
</fieldset>